import React, { Component } from 'react';
import { Modal, Select, Input, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;

class RegisterLeave extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        userLeaveToList: [],
        userLeaveReasonList: [],
        userLeaveToPositionList: [],
    }

    show = (params) => {
        this.setState({
            params,
            visible: true,
        }, () => {
            this.getConfig();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    getConfig = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.getLeaveConfig,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { userLeaveReasonList, userLeaveToList, userLeaveToPositionList } = res;
                this.setState({
                    loading: false,
                    userLeaveToList,
                    userLeaveReasonList,
                    userLeaveToPositionList,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const {
            params: {
                userId,
                firstLeaveToId,
                secondLeaveToId, 
                leaveToComments,
                userLeaveToPositionId,
                positionComments,
                firstReasonId,
                secondReasonId,
            },
        } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.saveUserLeaveReason,
            data: {
                userId,
                firstLeaveToId,
                secondLeaveToId, 
                leaveToComments,
                userLeaveToPositionId,
                positionComments,
                firstReasonId,
                secondReasonId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if (key == 'firstLeaveToId') {
            params.secondLeaveToId = undefined;
            params.leaveToComments = '';
        } else if (key == 'userLeaveToPositionId') {
            params.positionComments = '';
        } else if (key == 'firstReasonId') {
            params.secondReasonId = undefined;
        }
        this.setState({ params });
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    getContent = () => {
        const {
            params,
            userLeaveToList,
            userLeaveReasonList,
            userLeaveToPositionList,
        } = this.state;
        const {
            leftTime,
            userCompellation,
            employeeCode,
            firstLeaveToId,
            secondLeaveToId, 
            leaveToComments,
            userLeaveToPositionId,
            positionComments,
            firstReasonId,
            secondReasonId,
        } = params;
        const userLeaveToOptions = userLeaveToList.map(i => <Option key={i.userLeaveToId}>{i.whereToLeave}</Option>);
        const userLeaveReasonOptions = userLeaveReasonList.map(i => <Option key={i.userLeaveReasonId}>{i.reason}</Option>);
        const userLeaveToPositionOptions = userLeaveToPositionList.map(i => <Option key={i.userLeaveToPositionId}>{i.positionName}</Option>);
        const userLeaveTo = firstLeaveToId ? userLeaveToList.find(i => i.userLeaveToId == firstLeaveToId) : '';
        const leaveToName = userLeaveTo ? userLeaveTo.whereToLeave : '';
        const userLeaveReason = firstReasonId ? userLeaveReasonList.find(i => i.userLeaveReasonId == firstReasonId) : '';
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">人员:</div>
                    <div className="item-right">
                            {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">离职时间:</div>
                    <div className="item-right">
                        {leftTime ? leftTime.slice(0, 10) : ''}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">离职去向:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={firstLeaveToId ? String(firstLeaveToId) : undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'firstLeaveToId')}
                        >
                           { userLeaveToOptions }
                        </Select>
                    </div>
                </li>
                {
                    leaveToName && (
                        leaveToName === 'SMO' ?
                            <li className="modal-item">
                                <div className="item-left">&nbsp;</div>
                                <div className="item-right">
                                    <Select
                                        style={{ width: 182 }}
                                        value={secondLeaveToId ? String(secondLeaveToId) : undefined}
                                        placeholder="请选择SMO公司"
                                        onChange={value => this.handleSelectChange(value, 'secondLeaveToId')}
                                    >
                                        { userLeaveTo.childList.map(i => <Option key={i.userLeaveToId}>{i.whereToLeave}</Option>) }
                                    </Select>
                                </div>
                            </li>
                        :
                            <li className="modal-item">
                                <div className="item-left">&nbsp;</div>
                                <div className="item-right">
                                    <Input
                                        value={leaveToComments}
                                        style={{ width: 182 }}
                                        placeholder={
                                            leaveToName === '药企/器械公司等' ? '请填写药企、器械公司名称' :
                                                leaveToName === 'CRO' ? '请填写CRO' : '填写其他单位名称'
                                        }
                                        onChange={e => this.handleInputChange(e, 'leaveToComments')}
                                    />
                                </div>
                            </li>
                    )
                }
                {
                    secondLeaveToId == '25' &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <Input
                                value={leaveToComments}
                                style={{ width: 182 }}
                                placeholder="请补充其他备注"
                                onChange={e => this.handleInputChange(e, 'leaveToComments')}
                            />
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left">去向职位:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={userLeaveToPositionId ? String(userLeaveToPositionId) : undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'userLeaveToPositionId')}
                        >
                           { userLeaveToPositionOptions }
                        </Select>
                    </div>
                </li>
                {
                    userLeaveToPositionId == '5' &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <Input
                                value={positionComments}
                                style={{ width: 182 }}
                                placeholder="请补充其他备注"
                                onChange={e => this.handleInputChange(e, 'positionComments')}
                            />
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left">离职原因:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={firstReasonId ? String(firstReasonId) : undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'firstReasonId')}
                        >
                           { userLeaveReasonOptions }
                        </Select>
                    </div>
                </li>
                {
                    userLeaveReason &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <Select
                                style={{ width: 182 }}
                                value={secondReasonId ? String(secondReasonId) : undefined}
                                placeholder="请选择离职原因"
                                onChange={value => this.handleSelectChange(value, 'secondReasonId')}
                            >
                                { userLeaveReason.childList.map(i => <Option key={i.userLeaveReasonId}>{i.reason}</Option>) }
                            </Select>
                        </div>
                    </li>
                }
            </ul>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="登记离职信息"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default RegisterLeave;


// WEBPACK FOOTER //
// ./src/components/user/userInfo/RegisterLeave.js